import Maintenance from 'pages/CatalogPage/DH/Maintenance/Maintenance';

export default Maintenance;
